import { render, staticRenderFns } from "./FavoriteStar.vue?vue&type=template&id=dbd7db6e&scoped=true&"
import script from "./FavoriteStar.vue?vue&type=script&lang=js&"
export * from "./FavoriteStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd7db6e",
  null
  
)

export default component.exports